if(!customElements.get('cart-drawer')){
  class CartDrawer extends HTMLElement {
    constructor(){
      super();

      this.handleEscape = this.handleEscape.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);

      this.init();
    }

    init(){
      this.btnClose = this.querySelector('.btn-close');

      if(this.btnClose){
        this.btnClose.addEventListener('click', () => {
          this.close();
        });
      }

      this.quantitySelectors = this.querySelectorAll('quantity-selector');
      this.quantitySelectors.forEach(item => {
        var btnRemoveQuantity = item.querySelector('[data-action="remove"]');
        var btnAddQuantity = item.querySelector('[data-action="add"]');
        var input = item.querySelector('.input-quantity');

        if(btnRemoveQuantity){
          btnRemoveQuantity.addEventListener('click', this.updateQuantity.bind(this));
          btnRemoveQuantity.addEventListener('keydown', e => {
            if(e.key === 'Enter'){
              this.updateQuantity(e);
            }
          });
        }

        if(btnAddQuantity){
          btnAddQuantity.addEventListener('click', this.updateQuantity.bind(this));
          btnAddQuantity.addEventListener('keydown', e => {
            if(e.key === 'Enter'){
              this.updateQuantity(e);
            }
          });
        }

        if(input){
          input.addEventListener('input', this.updateQuantity.bind(this));
        }
      });

      this.btnItemRemoves = this.querySelectorAll('.btn-item-remove');
      this.btnItemRemoves.forEach(item => {
        item.addEventListener('click', this.clickItemRemove.bind(this));
      });

      this.errorMsgs = this.querySelectorAll('.cart-item__errors');

      this.removeEventListener('click', this.handleOverlayClick);
      this.addEventListener('click', this.handleOverlayClick);
    }

    refresh(){
      this.init();
    }

    open(){
      this.previouslyFocusedElement = document.activeElement;

      document.querySelector('html').style.overflow = 'hidden';
      this.setAttribute('data-hidden', 'false');

      document.removeEventListener('keydown', this.handleEscape);
      document.addEventListener('keydown', this.handleEscape);

      setTimeout(() => {
        if(this.btnClose){
          this.btnClose.focus();
        }
      }, 1000);
    }

    close(){
      this.setAttribute('data-hidden', 'true');
      document.querySelector('html').style.overflow = 'initial';
      document.removeEventListener('keydown', this.handleEscape);

      if(this.previouslyFocusedElement){
        this.previouslyFocusedElement.focus();
      }
    }

    handleEscape(event){
      if(event.key === 'Escape') this.close();
    }

    handleOverlayClick(e){
      if(e.target === this){
        this.close();
      }
    }

    updateQuantity(e){
      var btn = e.currentTarget;
      var input = btn.classList.contains('input-quantity') ? btn : btn.closest('.quantity-wrapper').querySelector('input[name="quantity"]');
      var quantity = input.value;
      var line = input.dataset.idx;
      var previousQuantity = input.getAttribute('value');

      if(!btn.classList.contains('input-quantity')){
        if(btn.dataset.action === 'add'){
          previousQuantity = `${parseInt(quantity) - 1}`;
        }else if(btn.dataset.action === 'remove'){
          previousQuantity = `${parseInt(quantity) + 1}`;
        }
      }

      this.clearErrors();
      this.setLineLoading(line, true);
      this.updateLine(line, quantity, previousQuantity);
    }

    clickItemRemove(e){
      e.preventDefault();

      var btnRemove = e.currentTarget;
      var line = btnRemove.dataset.idx;
      var input = this.querySelector(`.cart-item[data-idx="${line}"] .input-quantity`);
      var previousQuantity = input ? input.getAttribute('value') : '0';

      this.clearErrors();
      this.setLineLoading(line, true);
      this.updateLine(line, 0, previousQuantity);
    }

    updateLine(line, quantity, previousQuantity){
      var formData = new FormData();
      formData.append('line', `${line}`);
      formData.append('quantity', quantity);
      formData.append('sections', 'cart-drawer,header-cart-icon');
      formData.append('sections_url', window.location.pathname);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${routes.cart_change_url}`, config)
      .then(res => res.json())
      .then(res => {
        if(res.status){
          var cartItem = this.querySelector(`.cart-item[data-idx="${line}"]`);
          if(cartItem){
            cartItem.querySelector('.cart-item__errors .error').innerHTML = `${res.message}`;
            cartItem.querySelector('.cart-item__errors').setAttribute('data-hidden', 'false');

            var currentInput = cartItem.querySelector('.input-quantity');
            if(currentInput){
              currentInput.value = previousQuantity;
              currentInput.setAttribute('value', previousQuantity);
            }
          }

          this.setLineLoading(line, false);
          return;
        }

        this.renderFromSections(res.sections);
      })
      .catch(error => {
        console.error(error);
        this.setLineLoading(line, false);
      });
    }

    renderFromSections(sections){
      if(sections['cart-drawer']){
        const pageHTML = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const cartDrawer = pageHTML.querySelector('cart-drawer');

        if(cartDrawer){
          this.innerHTML = cartDrawer.innerHTML;

          if(cartDrawer.getAttribute('data-id')){
            this.setAttribute('data-id', cartDrawer.getAttribute('data-id'));
          }

          this.refresh();
        }
      }

      if(sections['header-cart-icon']){
        const cartCountValue = sections['header-cart-icon'].trim();

        document.querySelectorAll('custom-header .cart-count').forEach(item => {
          item.innerHTML = cartCountValue;
          item.setAttribute('data-hidden', parseInt(cartCountValue) > 0 ? 'false' : 'true');
        });
      }
    }

    clearErrors(){
      if(!this.errorMsgs) return;

      this.errorMsgs.forEach(item => {
        item.setAttribute('data-hidden', 'true');
        item.querySelector('.error').innerHTML = '';
      });
    }

    setLineLoading(line, status){
      var spinner = this.querySelector(`.cart-item[data-idx="${line}"] .heading .spinner`);
      if(spinner){
        spinner.setAttribute('data-loading-status', status ? 'true' : 'false');
      }

      var overlay = this.querySelector(`.cart-item[data-idx="${line}"] .cart-item__loading-overlay`);
      if(overlay){
        overlay.setAttribute('data-hidden', status ? 'false' : 'true');
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer)
}
